import React from 'react';
import { Box } from 'rebass/styled-components';

import { VerifyEmail as VerifyEmailComponent } from '../../components/molecules/verifyEmail';
import BlankLayout from '../../components/layout/Blank';

export const VerifyEmail = () => (
  <BlankLayout>
    <Box p="24px" width="600px" mt="60px">
      <Box maxWidth="520px" mx="auto">
        <VerifyEmailComponent />
      </Box>
    </Box>
  </BlankLayout>
);
